import {
  projectHarmonizationPropertiesQuery,
  updateHarmonizationStatusMutation
} from '@prophecy/queries/common/queries/project';
import { useQueryClient } from '@tanstack/react-query';

import { useGraphQlMutation, useGraphQlQuery } from '../../../data/util';
import { QueryKeys } from '../../queries/common';
import { ProjectHarmonizationPropertiesResponse } from '../../queries/project';
import { HarmonizationStatus } from '../../types';

export function useProjectHarmonizationProperties(projectId: string, enabled = true) {
  const { data, ...rest } = useGraphQlQuery<ProjectHarmonizationPropertiesResponse, { projectId: string }>(
    [QueryKeys.Project, 'ProjectHarmonizationProperties', { projectId }],
    projectHarmonizationPropertiesQuery,
    { enabled: enabled && Boolean(projectId) },
    { projectId }
  );

  return {
    harmonizationProperties: data?.Project?.harmonizationProperties ?? null,
    ...rest
  };
}

export function useUpdateHarmonizationStatus(projectId?: string) {
  const queryClient = useQueryClient();
  const { mutateAsync, ...rest } = useGraphQlMutation<number, { uid: string; status: `${HarmonizationStatus}` }>(
    updateHarmonizationStatusMutation,
    {
      onSuccess: () => {
        if (projectId) {
          queryClient.invalidateQueries([QueryKeys.Project, 'ProjectHarmonizationProperties', { projectId }]);
        }
      }
    }
  );

  return {
    updateHarmonizationStatus: mutateAsync,
    ...rest
  };
}
